import React, { FC, useState } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { postCommissions } from '../../store/order/actions/agencies';

interface Props {
	status: string;
	id: string;
}
export const CommissionsPost: FC<Props> = (props) => {
	const { status, id } = props;

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const openModal = (): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Post',
			modalText: 'Post',
			onClose: closeModal,
			onCancel: closeModal,
			onConfirm: async (): Promise<void> => {
				await postCommissions(id);
				closeModal();
				},
    });
	};

	return (
		<>
			<ButtonComponent
				buttonType={BUTTON_TYPE.WHITE}
				buttonName='Post'
				isDisabled={status !== 'Unpaid'}
				additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3"
				onButtonClick={openModal}
			/>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};